<template>
  <section class="l-content-area">
    <div class="l-content l-content--reservation">
      <div class="l-wrap__outer">
        <div class="l-wrap__inner">
          <section class="c-title__bloc c-title__bloc--reservation">
            <h1>新規来店予約申し込み登録</h1>
            <div class="c-btn c-btn--title-back"><a href="#">戻る</a></div>
          </section>
          <section class="p-bloc p-bloc__reservation">
            <h2 class="p-reservation__step">
              {{ isDesignCut ? 'STEP 5' : 'STEP 6' }}
            </h2>
            <div class="p-reservation__bloc">
              <p>お手数ですが下記のアンケートにご回答をお願いいたします。</p>
              <div class="p-reservation__contact">
                <dl class="c-contact-parts">
                  <dt>他社製品・サービスのご利用について</dt>
                  <dd>
                    <input-radio
                      :value="values.experience"
                      :error="errors.experience"
                      :text-error="textErrors.experience"
                      :name="'experience'"
                      :list-data="listExperience"
                      @onHandleChange="onHandleChange"
                      @onValidate="onValidate"
                    >
                    </input-radio>
                  </dd>
                  <dt v-show="values.experience === '1'">
                    どのような製品・サービスですか？<span>※複数回答可</span>
                  </dt>
                  <dd>
                    <ul
                      v-show="values.experience === '1'"
                      :class="`checkbox-area ${errors.service ? 'is-error' : ''}`"
                    >
                      <li v-for="(service, index) in listService" :key="index">
                        <input
                          :id="index + 100"
                          type="checkbox"
                          :value="service.id"
                          :checked="values.service.indexOf(service.id) !== -1"
                          @change="getValueSelected($event, service.id)"
                          @input="service.id = $event.target.value"
                        />
                        <label :for="index + 100">
                          <span>{{ service.name }}</span>
                        </label>
                      </li>
                    </ul>

                    <p class="error-txt">{{ errors.service }}</p>
                  </dd>
                  <dt>ご質問・ご要望<span>※入力は100文字まで</span></dt>
                  <dd>
                    <text-area
                      :name="'request'"
                      :max-length="100"
                      :value="values.request"
                      :placeholder="'ご質問・ご要望等ございましたらご入力をお願いいたします。'"
                      :text-error="textErrors.request"
                      :error="errors.request"
                      :is-show-error="false"
                      :pattern="regex"
                      @onValidate="onValidate"
                      @onHandleChange="onHandleChange"
                    >
                    </text-area>
                    <error-message v-if="errors.request" :error="errors.request"></error-message>
                  </dd>
                </dl>
              </div>
            </div>
            <button-registration
              :next-text="'次へ'"
              :prev-text="'戻る'"
              :handle-next-button="nextToStep"
              :handle-prev-button="prevToStep"
              :prev-text-color="'#787878'"
            >
            </button-registration>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { listService } from '../../constant/listServices'
import TextArea from '../common/TextArea.vue'
import ButtonRegistration from '../common/ButtonRegistration'
import { EXPERIENCE_INVALID, SERVICE_INVALID, REQUEST_INVALID } from '../../constant/text'
import {
  rulesValidateReservationNextQuestion,
  rulesValidateArrayRequired,
  rulesValidateReservationNextQuestionNoService,
} from '../../helpers/schemaValidate'
import InputRadio from '../common/InputRadio'
import { listExperience } from '../../constant/listQuestions'
import { requestSurvey } from '../../actions/requestReservation'
import { scrollToTop } from '../../helpers'
import * as regex from '../../helpers/regex'
import ErrorMessage from '../common/ErrorMessage'

export default {
  name: 'ReservationNextQuestion',
  components: {
    InputRadio,
    TextArea,
    ButtonRegistration,
    ErrorMessage,
  },
  props: {
    currentStep: {
      type: String,
      default: '6',
    },
    isDesignCut: {
      type: Boolean,
      default: false,
    },
    isConclusion: {
      type: Boolean,
      default: false,
    },
    isForceValidate: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: String,
      default: '',
    },
    surveyId: {
      type: String,
      default: '',
    },
    values: {
      type: Object,
      default: () => {
        return {
          experience: '',
          service: [],
          request: '',
        }
      },
    },
  },
  data() {
    return {
      listService,
      listExperience,
      errors: {
        experience: '',
        service: '',
        request: '',
      },
      textErrors: {
        experience: EXPERIENCE_INVALID,
        service: SERVICE_INVALID,
        request: REQUEST_INVALID,
      },
      regex: regex.patternEmoji,
    }
  },
  watch: {
    isForceValidate(newVal) {
      if (
        newVal &&
        ((!this.isConclusion && this.currentStep === '6') ||
          (this.isConclusion && this.currentStep === '7'))
      ) {
        this.nextToStep()
      }
    },
    'values.service'() {
      this.onValidateService()
    },
    'values.experience'(value) {
      if (value === '0') {
        this.errors.service = ''
      }
    },
  },
  methods: {
    getValueSelected(e, value) {
      const {
        target: { checked },
      } = e
      const listServiceSelected = [...this.values.service]
      if (checked) {
        listServiceSelected.push(value)
        this.onHandleChange('service', listServiceSelected)
      } else {
        const newListService = listServiceSelected.filter(
          service => service.toString() !== value.toString()
        )
        this.onHandleChange('service', newListService)
      }
    },
    nextToStep() {
      if (!this.values.experience || this.values.experience === '0') {
        rulesValidateReservationNextQuestionNoService
          .validate(this.values, { abortEarly: false })
          .then(() => {
            this.$emit('startLoading')
            this.values.request = this.values.request.replaceAll(regex.patternEmojiRestrict, '')
            this.errors = {}
            requestSurvey(this.userId, this.values, this.surveyId)
              .then(response => {
                const {
                  data: { success },
                } = response
                if (success === 1) {
                  const {
                    data: { data },
                  } = response
                  this.$emit('setSurveyId', data.id.toString())
                  this.$emit('nextToPage')
                  this.$emit('endLoading')
                }
              })
              .catch(error => {
                return error
              })
          })
          .catch(err => {
            scrollToTop(0, 0)
            err.inner.forEach(error => {
              this.errors[error.path] = error.message
              this.$emit('endLoading')
            })
          })
      } else {
        rulesValidateReservationNextQuestion
          .validate(this.values, { abortEarly: false })
          .then(() => {
            this.$emit('startLoading')
            this.values.request = this.values.request.replaceAll(regex.patternEmojiRestrict, '')
            this.errors = {}
            requestSurvey(this.userId, this.values, this.surveyId)
              .then(response => {
                const {
                  data: { success },
                } = response
                if (success === 1) {
                  const {
                    data: { data },
                  } = response
                  this.$emit('setSurveyId', data.id.toString())
                  this.$emit('nextToPage')
                  this.$emit('endLoading')
                }
              })
              .catch(error => {
                return error
              })
          })
          .catch(err => {
            scrollToTop(0, 0)
            err.inner.forEach(error => {
              this.errors[error.path] = error.message
              this.$emit('endLoading')
            })
          })
      }
    },
    prevToStep() {
      this.$emit('prevToStep', '5')
    },
    onValidateExperience() {
      this.errors.experience = ''
    },
    onHandleChange(field, value) {
      this.$emit('onHandleChange', field, value)
    },
    onValidate(field, value) {
      this.errors[field] = value
      this.$emit('onValidateSwipe', false)
    },
    onValidateService() {
      const values = {
        service: this.values.service,
      }
      rulesValidateArrayRequired('service', this.textErrors.service)
        .validateAt('service', values)
        .then(() => {
          this.onValidate('service', '')
        })
        .catch(error => {
          this.onValidate('service', error.message)
        })
    },
  },
}
</script>

<style scoped>
.v-application ul,
.v-application ol {
  padding-left: 0 !important;
}

.v-application a {
  color: #0a005a;
}
</style>
